module.exports = __webpack_public_path__ + "src/assets/img/pic (7).ce94e1e7.jpg";